import { Point } from "./Point";
export class Vector implements IVector {
    constructor(public x: number, public y: number) {
        // this.X = x; this.Y = y;
    }

    clone() {
        return new Vector(this.x, this.y);
    }
    // get X(): number {
    //     return this.X;
    // }
    // set X(x: number) {
    //     this.X = x;
    // }

    // get Y(): number {
    //     return this.Y;
    // }
    // set Y(y: number) {
    //     this.X = y;
    // }

    get length(): number {
        return Math.sqrt(this.dot(this))
    }

    get lengthSquared(): number {
        return this.dot(this);
    }

    private dot(vector: Vector): number {
        return this.x * vector.x + this.y * vector.y;
    }
    // private dot():number{
    //     return this.X * this.X + this.Y * this.Y;
    // }
    // static dot(left:Vector,right:Vector):number{
    //     return left.X * right.X + left.Y * right.Y;
    // }

    angleTo(vector: Vector): number {
        return Math.acos(this.dot(vector) / (this.length * vector.length));
    }

    normalize() {
        let length = Math.sqrt(this.x * this.x + this.y * this.y); //calculating length
        this.x = this.x / length; //assigning new value to x (dividing x by length of the vector)
        this.y = this.y / length; //assigning new value to y
    }

    distance(distance: number): Vector {
        this.normalize();
        return Vector.multiplyVectorScalar(this, distance);
    }

    static addPoint(vector: Vector, point: Point): Point {
        let x = vector.x + point.x;
        let y = vector.y + point.y;
        return new Point(x, y);
    }

    static addVector(vector1: Vector, vector2: Vector): Vector {
        let x = vector1.x + vector2.x;
        let y = vector1.y + vector2.y;
        return new Vector(x, y);
    }

    static angleBetween(vector1: Vector, vector2: Vector): number {
        let sin = vector1.x * vector2.y - vector2.x * vector1.y;
        let cos = vector1.x * vector2.x + vector1.y * vector2.y;
        return Math.atan2(sin, cos) * (180 / Math.PI);
        //return vector1.angleTo(vector2);
    }

    static divide(vector: Vector, scalar: Vector | number): Vector {

        return new Vector(1, 1); // TODO: Add Math
    }

    static multiply(vector1: Vector, vector2: Vector): Vector {
        let x = vector1.x * vector2.x;
        let y = vector1.y * vector2.y;
        return new Vector(x, y);
    }

    static multiplyScalar(scalar: number, vector: Vector): Vector {
        return new Vector(1, 1); // TODO: Add Math
    }

    static multiplyVectorScalar(vector: Vector, scalar: number): Vector {
        let x = vector.x * scalar;
        let y = vector.y * scalar;
        return new Vector(x, y);
    }

    static subtract(vector1: Vector, vector2: Vector): Vector {
        let x = vector1.x - vector2.x;
        let y = vector1.y - vector2.y;
        return new Vector(x, y);
    }

    static distance(vector: Vector, distance: number): Vector {
        vector.normalize();
        return Vector.multiplyVectorScalar(vector, distance);
    }

    static directionFromAngle(angle: number): Vector {
        var angleInRadians = (angle + 90) / (180 / Math.PI);
        return new Vector(Math.sin(angleInRadians), Math.cos(angleInRadians));
    }
}

export interface IVector {
    x: number;
    y: number;
}